import Vue from "vue";

Vue.filter("boolean", value => {
  return value ? "✔" : "✘";
});
